import _ from "lodash";
import { scheduleSessionApiCall, SessionKeys } from "../../../utils/AppUtils";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getScheduledSessions } from "../../../redux/events/actions";
import moment from "moment";

const SessionRequest = (props) => {
  const { coach, from, title } = props;
  const dispatch = useDispatch();
  const [sessionData, setSessionData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const sessionRes = useSelector(
    (state) => state.events.scheduledSessionResData
  );

  useEffect(() => {
    if (coach?.status === "completed") {
      setIsLoading(true);
      dispatch(
        getScheduledSessions({
          module: "scheduled-sessions",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          },
        })
      );
    }
  }, [coach]);

  useEffect(() => {
    if (!_.isEmpty(sessionRes)) {
      if (sessionRes?.status === "success") {
        console.log("sessionres---", sessionRes);
        setSessionData(sessionRes?.payload?.payload);
      } else {
        setSessionData();
      }
      setIsLoading(false);
    }
    return () => {};
  }, [sessionRes]);

  return (
    <>
      {coach?.status !== "completed" ? (
        from === "left" ? (
          <div
            className="card-money h-auto gap-10"
            tabIndex={0}
            aria-label="Take the tour. Learn where everything is so you can start digging into the content."
          >
            <div className="row mb-2 align-items-center">
              <div className="icon-left col-2">
                <svg
                  width="30"
                  height="48"
                  viewBox="0 0 30 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 25.5C13.5 25.5 12.12 25.13 10.86 24.39C9.60001 23.63 8.60001 22.62 7.86 21.36C7.12001 20.1 6.75 18.73 6.75 17.25C6.75 15.75 7.12001 14.37 7.86 13.11C8.60001 11.85 9.60001 10.85 10.86 10.11C12.12 9.37 13.5 9 15 9C16.5 9 17.88 9.37 19.14 10.11C20.4 10.85 21.4 11.85 22.14 13.11C22.88 14.37 23.25 15.75 23.25 17.25C23.25 18.75 22.88 20.13 22.14 21.39C21.4 22.65 20.4 23.65 19.14 24.39C17.88 25.13 16.5 25.5 15 25.5ZM15 10.83C13.84 10.83 12.77 11.12 11.79 11.7C10.81 12.28 10.03 13.06 9.45001 14.04C8.89001 15.02 8.61001 16.09 8.61001 17.25C8.61001 18.41 8.89001 19.48 9.45001 20.46C10.03 21.44 10.81 22.22 11.79 22.8C12.77 23.36 13.84 23.64 15 23.64C16.16 23.64 17.23 23.36 18.21 22.8C19.19 22.22 19.96 21.44 20.52 20.46C21.1 19.48 21.39 18.41 21.39 17.25C21.39 16.09 21.1 15.02 20.52 14.04C19.96 13.06 19.19 12.28 18.21 11.7C17.23 11.12 16.16 10.83 15 10.83ZM27.3 29.16C27.46 29.24 27.59 29.36 27.69 29.52C27.81 29.66 27.87 29.82 27.87 30V38.07C27.87 38.33 27.78 38.55 27.6 38.73C27.42 38.91 27.2 39 26.94 39H3.06C2.8 39 2.58 38.91 2.4 38.73C2.22 38.55 2.13 38.33 2.13 38.07V30C2.13 29.82 2.18 29.66 2.28 29.52C2.38 29.36 2.52 29.24 2.7 29.16C5.08 28.12 7.74001 27.41 10.68 27.03C13.56 26.67 16.44 26.67 19.32 27.03C22.26 27.41 24.92 28.12 27.3 29.16ZM15 30.9L14.04 34.17L14.94 35.1L15.96 34.14L15 30.9ZM26.01 37.17V30.63C23.37 29.59 20.62 28.96 17.76 28.74L16.14 29.28L17.97 34.26C18.05 34.48 18.04 34.7 17.94 34.92C17.86 35.14 17.72 35.3 17.52 35.4L14.88 37.38L12.42 35.37C12.22 35.27 12.08 35.11 12 34.89C11.94 34.69 11.95 34.48 12.03 34.26L13.86 29.28L12.24 28.74C9.38 28.96 6.63 29.59 3.99 30.63V37.17H26.01Z"
                    fill="#474747"
                  ></path>
                </svg>
              </div>
              <h3 className="card-money-title col-8 ps-0 mb-0">
                Get started with a coach
              </h3>
            </div>
            <p className="small-text-money">
              Talk with a coach to build a personalized plan, stay motivated,
              and get expert guidance.
            </p>
            <div class="btnsec mt-10">
              <button
                class="session-btn mt-0"
                tabIndex={0}
                onClick={() => {
                  scheduleSessionApiCall();
                  window.open(coach?.coach_url, "_blank");
                }}
              >
                Schedule a session
              </button>
            </div>
          </div>
        ) : (
          <div
            className={`card-money justify-content-between ${
              from === "right" ? "h-auto" : ""
            }`}
            tabIndex="0"
            aria-label="Take the tour. Learn where everything is so you can start digging into the content."
          >
            <div className="caochtext">
              <div class=" mb-10 align-items-center">
                <h3 className="card-money-title col-12 mb-0">
                  {title?title:"Get started with a coach"}
                </h3>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="coach-img">
                  <img
                    src="/images/finwell-img/Success.svg"
                    alt="Coach"
                    className="img-fluid"
                  />
                </div>
                <p className="small-text-money">
                  Talk with a coach to build a personalized plan, stay
                  motivated, and get expert guidance.
                </p>
              </div>
            </div>
            <div className="btnsec mt-3">
              <button
                className="session-btn mt-0"
                tabIndex={0}
                onClick={() => {
                  scheduleSessionApiCall();
                  window.open(coach?.coach_url, "_blank");
                }}
              >
                Schedule a session
              </button>
            </div>
          </div>
        )
      ) : (
        <>
          <div
            className={`card-money justify-content-between ${
              from === "right" ? "h-auto" : ""
            }`}
            tabindex="0"
            aria-label="Take the tour. Learn where everything is so you can start digging into the content."
          >
            <div className="caochtext">
              <div className=" mb-3 align-items-center">
                <h3 className="card-money-title col-12 mb-0">
                  Time for a check-in?
                </h3>
                <p className="sub-head-bx">Let’s take the next step.</p>
              </div>
              <div className="d-flex align-items-center gap-3">
                <div className="coach-imgimg">
                  {sessionData?.coach_img ? (
                    <img
                      src={
                        sessionData?.coach_img
                          ? sessionData?.coach_img
                          : "/images/finwell-img/avatar3.png"
                      }
                      width="40"
                      height="40"
                      alt="Coach"
                      className="img-fluid"
                    />
                  ) : (
                    <span className="user-deaf">
                                              <svg
                      width="40"
                      height="40"
                      viewBox="0 0 30 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 25.5C13.5 25.5 12.12 25.13 10.86 24.39C9.60001 23.63 8.60001 22.62 7.86 21.36C7.12001 20.1 6.75 18.73 6.75 17.25C6.75 15.75 7.12001 14.37 7.86 13.11C8.60001 11.85 9.60001 10.85 10.86 10.11C12.12 9.37 13.5 9 15 9C16.5 9 17.88 9.37 19.14 10.11C20.4 10.85 21.4 11.85 22.14 13.11C22.88 14.37 23.25 15.75 23.25 17.25C23.25 18.75 22.88 20.13 22.14 21.39C21.4 22.65 20.4 23.65 19.14 24.39C17.88 25.13 16.5 25.5 15 25.5ZM15 10.83C13.84 10.83 12.77 11.12 11.79 11.7C10.81 12.28 10.03 13.06 9.45001 14.04C8.89001 15.02 8.61001 16.09 8.61001 17.25C8.61001 18.41 8.89001 19.48 9.45001 20.46C10.03 21.44 10.81 22.22 11.79 22.8C12.77 23.36 13.84 23.64 15 23.64C16.16 23.64 17.23 23.36 18.21 22.8C19.19 22.22 19.96 21.44 20.52 20.46C21.1 19.48 21.39 18.41 21.39 17.25C21.39 16.09 21.1 15.02 20.52 14.04C19.96 13.06 19.19 12.28 18.21 11.7C17.23 11.12 16.16 10.83 15 10.83ZM27.3 29.16C27.46 29.24 27.59 29.36 27.69 29.52C27.81 29.66 27.87 29.82 27.87 30V38.07C27.87 38.33 27.78 38.55 27.6 38.73C27.42 38.91 27.2 39 26.94 39H3.06C2.8 39 2.58 38.91 2.4 38.73C2.22 38.55 2.13 38.33 2.13 38.07V30C2.13 29.82 2.18 29.66 2.28 29.52C2.38 29.36 2.52 29.24 2.7 29.16C5.08 28.12 7.74001 27.41 10.68 27.03C13.56 26.67 16.44 26.67 19.32 27.03C22.26 27.41 24.92 28.12 27.3 29.16ZM15 30.9L14.04 34.17L14.94 35.1L15.96 34.14L15 30.9ZM26.01 37.17V30.63C23.37 29.59 20.62 28.96 17.76 28.74L16.14 29.28L17.97 34.26C18.05 34.48 18.04 34.7 17.94 34.92C17.86 35.14 17.72 35.3 17.52 35.4L14.88 37.38L12.42 35.37C12.22 35.27 12.08 35.11 12 34.89C11.94 34.69 11.95 34.48 12.03 34.26L13.86 29.28L12.24 28.74C9.38 28.96 6.63 29.59 3.99 30.63V37.17H26.01Z"
                        fill="#474747"
                      ></path>
                    </svg>
                    </span>
                  )}
                </div>
                <p className="user-title-money mb-0">
                  {sessionData?.coach_name}
                </p>
              </div>
              {!_.isEmpty(sessionData?.session_date) && (
                <div
                  className={`pill-date mb-0 ${
                    sessionData?.type === "session" ? "next-session" : "last-ses"
                  }`}
                >
                  {sessionData?.type === "session" ? "Next" : "Last"} session:{" "}
                  {moment(
                    sessionData?.session_date,
                    "DD MMM YYYY HH:mm"
                  ).format("MMMM DD, YYYY")}
                </div>
              )}
              {/* {!_.isEmpty(sessionData?.last_session_date) && (
                <div className="pill-date">
                  Last session: {sessionData?.last_session_date}
                </div>
              )} */}
              <div className="btnsdc mt-3">
                <button
                  className="link-btn p-0 text-decoration-underline border-0"
                  tabIndex={0}
                  onClick={() => {
                    scheduleSessionApiCall();
                    window.open(coach?.coach_url, "_blank");
                  }}
                >
                  Schedule a coaching session
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default SessionRequest;
